import React, {Component} from 'react';
import {Card, Table} from 'antd';
import {queryFinanceInvestment} from '@api/incubator/finance';

import {BackBtn} from '@comm/BackBtn';
import baseData from '@util/base';
import util from '@util/index';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = { dataCash: [], dataAssets: [] };
  }

  componentDidMount() {
    this.getFinanceInvestment();
  }

  componentWillMount() {}

  handleClick = e => {};

  getFinanceInvestment = () => {
    queryFinanceInvestment({
      incubatorUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        const dataCash = [];
        const dataAssets = [];
        res.data.cash.init.forEach(item => {
          dataCash.push({
            type2: 'init',
            ...item,
          });
        });
        res.data.cash.after.forEach(item => {
          dataCash.push({
            type2: 'after',
            ...item,
          });
        });
        dataCash.push({
          type2: 'difference',
          type: 'difference',
          price: res.data.cash.difference,
        });
        res.data.assets.init.forEach(item => {
          dataAssets.push({
            type2: 'init',
            ...item,
          });
        });
        res.data.assets.after.forEach(item => {
          dataAssets.push({
            type2: 'after',
            ...item,
          });
        });
        dataAssets.push({
          type2: 'difference',
          type: 'difference',
          price: res.data.assets.difference,
        });
        this.setState({
          dataSource: res.data,
          dataCash,
          dataAssets,
        });
      }
    });
  };

  columns = type => {
    const { dataSource } = this.state;
    const type2Font = {
      init: '初值',
      after: '初值',
      difference: '差额',
    };
    const type1Font = {
      cash: '投资现金',
      assets: '投资资产',
    };
    return [
      {
        title: '值类别',
        dataIndex: 'type2',
        render: (text, record, index) => {
          let rowSpan = 1;
          if (record.type2 === 'init' && index === 0) {
            rowSpan = dataSource[type].init.length;
          } else if (record.type2 === 'init') {
            rowSpan = 0;
          } else if (record.type2 === 'after' && index === dataSource[type].init.length) {
            rowSpan = dataSource[type].after.length;
          } else if (record.type2 === 'after') {
            rowSpan = 0;
          }
          return {
            children: (
              <span>
                {type1Font[type]}
                {type2Font[text]}
              </span>
            ),
            props: {
              rowSpan,
            },
          };
        },
      },
      {
        title: '类型',
        dataIndex: 'type',
        render: (text, record) => {
          if (record.type !== 'difference') {
            return <span>{baseData.investmentType[text]}</span>;
          }
          return (
            <span>
              {type1Font[type]}现值-{type1Font[type]}初值
            </span>
          );
        },
      },
      {
        title: '金额',
        dataIndex: 'price',
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      },
    ];
  };

  render() {
    const { dataCash, dataAssets } = this.state;
    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
        </div>
        <Card title="投资现金回报计算">
          <div style={{ marginBottom: '16px' }}>
            <Table
              dataSource={dataCash}
              columns={this.columns('cash')}
              pagination={false}
              showHeader={false}
              bordered
            />
          </div>
          <Table
            dataSource={dataAssets}
            columns={this.columns('assets')}
            pagination={false}
            showHeader={false}
            bordered
          />
        </Card>
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/one/PageInvestment.js